import { ajax } from '../modules/ajax.js';
import { showModal } from '../modules/modal.js';
import { toggleSlider } from '../modules/range.js';

document.addEventListener("DOMContentLoaded", () => {
    const takeWorkBtn = document.getElementById('takeWork');
    const actActionBtn = document.getElementById('actAction');
    const takeWorkModal = document.getElementById('takeWorkModal');
    const takeWorkYes = document.getElementById('takeWorkConfirmYes');
    const takeWorkNo = document.getElementById('takeWorkConfirmNo');
    const completeTaskBtn = document.getElementById('completeTask');

    if (!takeWorkBtn) return;

	$('.select2_multi').on('change', function () {
		const $select = $(this);
		const $container = $select.next('.select2').find('.select2-selection');

		if ($select.val() && $select.val().length > 0) {
			$container.css('border', '');
		}
	});

	document.querySelectorAll("input, textarea").forEach(field => {
		field.addEventListener('input', e => {
			if (e.target.value.trim()) {
				e.target.style.borderColor = ''
			}
		})
	})

	const TEXT_EDIT = 'Редактировать';
	const TEXT_SAVE = 'Сохранить';

	const excludeOnEdit = ['sendAct', 'takeWork', 'actAction'];

	function toggleControls(enabled, excludeIds = []) {
		document.querySelectorAll('input, select, .btn--default, textarea, button[data-button-meter-checked]').forEach(el => {
			if (
                excludeIds.includes(el.id) ||
                (el.tagName === 'BUTTON' && el.closest('dialog')) ||
                el.name === 'Vp_diff' ||
                el.name === 'Vc_prev_transport' ||
                el.name === 'measure_method' ||
                el.name === 'certificated'
            ) return;

			el.disabled = !enabled;
		});
		completeTaskBtn.disabled = enabled
        document.querySelectorAll('.time-display').forEach(el => {
            el.dataset.disabled = !enabled ? 'true' : 'false';
        });
        document.querySelectorAll('.slider-container').forEach(container => {
            toggleSlider(container, !enabled);
        });
	}

    function handleSearch() {
        const searchTerm = this.value.toLowerCase().trim();
        const meter = this.closest('[data-meter-id]')

        meter.querySelectorAll('.custom-checkbox.act-info__seal').forEach(row => {
            const place = row.querySelector('[data-place]')?.dataset.place.toLowerCase() || '';
            const numbers = row.querySelector('[data-numbers]')?.dataset.numbers.toLowerCase() || '';

            const shouldShow = searchTerm === '' ||
                place.includes(searchTerm) ||
                numbers.includes(searchTerm);

            row.style.display = shouldShow ? '' : 'none';
        });
    }

    const searchInput = document.querySelector('.js-search-seals');
    if(searchInput) {
        searchInput.addEventListener('input', handleSearch);
    }

	takeWorkBtn.addEventListener('click', () => {
		takeWorkModal.style.display = 'flex';
	});

	takeWorkYes.addEventListener('click', () => {
	    ajax('/act/status', {
            method: 'PATCH',
            body: { act_id: $('#block_act').data('act-id'), status: 'В работе' }
        })
		.then(response => {
			$('#act-status').text('В работе')
			let e = new Event("click")
			actActionBtn.dispatchEvent(e)
			actActionBtn.disabled = false;
			takeWorkBtn.disabled = true;
			takeWorkBtn.style.display = 'none';
			takeWorkModal.style.display = 'none';
            $('#act_details').show();
            $('#block_object .act-info__row:hidden').show();
		})
		.catch(err => {
			showModal(err.message || 'Ошибка отправки данных', 'Ошибка');
            takeWorkModal.style.display = 'none';
		});
	});

	takeWorkNo.addEventListener('click', () => {
		takeWorkModal.style.display = 'none';
	});

	actActionBtn.addEventListener('click', e => {
		const isEditing = e.target.classList.contains('editable');

		if (isEditing) {
			saveActAction().then(response => {
				toggleControls(false, excludeOnEdit);
				e.target.textContent = TEXT_EDIT;
				e.target.classList.remove('editable');
			}).catch(err => {
				showModal(err.message || 'Ошибка сохранения данных', 'Ошибка');
			});
		} else {
			toggleControls(true, excludeOnEdit);
			e.target.textContent = TEXT_SAVE;
			e.target.classList.add('editable');
		}
	});

    $('.js-select-all-seals').change(e => {
        let $meter = $(e.target).closest('[data-meter-id]')
        $meter.find('.js-select-seal').prop('checked', e.target.checked)
    })

    CalcVp_Diff()

    document.querySelector('[name=Vp_mex]')?.addEventListener('input', CalcVp_Diff);
    document.querySelector('[name=Vp_sub]')?.addEventListener('input', CalcVp_Diff);
});

function saveActAction(){
	return new Promise((resolve, reject) => {
        const meters = []
        $('[data-meter-id]').each(function () {
            const uirg = []

            $(this).find('.js-uirg-field').each(function () {
                const name = $(this).attr('name');
                if (!name) return;

                let value;
                if ($(this).is('select')) {
                    value = $(this).val() || '';
                } else {
                    const type = $(this).attr('type') || 'text';
                    if (type === 'checkbox' || type === 'radio') {
                        if (!$(this).prop('checked')) return;
                        value = $(this).val() || true;
                    } else {
                        value = $(this).val() || '';
                    }
                }
                uirg.push({name, value});
            });

            const equipment = []
            $(this).find('.js-equipment').each(function () {
                equipment.push({
                    equipment_id: $(this).data('equipment-id'),
                    count: $(this).find('input[name="count"]').val(),
                    unsealed: $(this).find('input[name="unsealed"]').val(),
                    compliance: $(this).find('input[name="compliance"]').is(':checked') ? 1 : 0,
                    mode: $(this).find('select[name="mode"]').val() || [],
                });
            });

            const seals = []
            $(this).find('.js-select-seal:checked').each(function () {
                seals.push($(this).data('seal-id'));
            });

            meters.push({
                id: $(this).data('meter-id'),
                consumption_max: $(this).find('input[name="consumption_max"]').val(),
                consumption_current: $(this).find('input[name="consumption_current"]').val(),
                checked: $(this).find('[data-meter-checked]').removeData('meter-checked').data('meter-checked'),
                uirg: uirg,
                equipment: equipment,
                seals: seals,
            })
        });

        const violations = {};
        let reportId;

        $('.js-violations-inputs').find('input').each(function (){
            const name = $(this).attr('name')
            const value = $(this).val();

            const match = name.match(/^violations\[(\d+)](?:\[([^\]]+)\])?(?:\[([^\]]+)\])?$/);
            if (!match) return;

            const idx = parseInt(match[1]);
            const key1 = match[2];
            const key2 = match[3];

            if (key1 === 'report_id') {
                reportId = value;
                violations[idx] = {report: reportId, fields: {}};
            } else if (key1 === 'params' && key2 && violations[idx] && typeof violations[idx].fields === 'object') {
                violations[idx].fields[key2] = value;
            }
        });

		const act_id = $('#block_act').data('act-id')
		const contact_id = $('#block_contact').find('select[name="contact"]').val()

        const filesData = $('#block_files').data('files-data') || [];

        const formData = new FormData();

        formData.append('meters', JSON.stringify(meters));
        formData.append('violations', JSON.stringify(violations));
        formData.append('contact_id', contact_id);

        filesData.forEach((fileData) => {
            formData.append('comments[]', fileData.comment || '');
            formData.append('is_new[]', fileData.file ? '1' : '0');
            if (fileData.file) {
                formData.append('files[]', fileData.file);
                formData.append('new_ids[]', fileData.id);
            } else {
                formData.append('existing_ids[]', fileData.id);
            }
        });

        ajax(`/act/${act_id}`, {
            method: 'POST',
            body: formData
        })
            .then((response) => {
                const mapping = response.files || {};

                const currentFilesData = $('#block_files').data('files-data') || [];
                const updatedFilesData = currentFilesData.map(file => {
                    const fileData = mapping[file.id];
                    if (fileData) {
                        return {
                            ...file,
                            id: fileData.id,
                            file: null,
                            name: fileData.name
                        };
                    }
                    return file;
                });

                Object.entries(mapping).forEach(([id, fileData]) => {
                    const elems = document.querySelectorAll(`[data-file-id="${id}"]`);
                    elems.forEach(el => {
                        el.dataset.fileId = fileData.id
                        if (el.classList.contains('file-preview-link')) {
                            el.textContent = fileData.name;
                        }
                    });
                });

                $('#block_files').data('files-data', updatedFilesData);
                resolve(response);
            })
            .catch(reject);
	});
}

function CalcVp_Diff () {
    const Vp_mex_el = document.querySelector('[name=Vp_mex]');
    const Vp_sub_el = document.querySelector('[name=Vp_sub]');
    const Vp_diff_el = document.querySelector('[name=Vp_diff]');

    if (!Vp_mex_el || !Vp_sub_el || !Vp_diff_el) return;

    const Vp_mex = parseFloat(Vp_mex_el.value) || 0;
    const Vp_sub = parseFloat(Vp_sub_el.value) || 0;

    Vp_diff_el.value = Vp_mex - Vp_sub;
}
